import { render, staticRenderFns } from "./Register_Desktop.vue?vue&type=template&id=391f33e0&scoped=true&"
import script from "./Register_Desktop.vue?vue&type=script&lang=js&"
export * from "./Register_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Register_Desktop.vue?vue&type=style&index=0&id=391f33e0&prod&lang=css&"
import style1 from "./Register_Desktop.vue?vue&type=style&index=1&id=391f33e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f33e0",
  null
  
)

export default component.exports